import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLongArrowRight } from '@fortawesome/pro-light-svg-icons';
import theme from './StandardReplies.module.scss';
import EditStandardReplyModal from './EditStandardReplyModal';

interface StandardRepliesEmptyProps {
    onCreate(): void;
}

export enum CompanySettingsTabs {
    Profile = 'profile',
    StandardReplies = 'standard-replies',
}

const StandardRepliesEmpty: React.FC<StandardRepliesEmptyProps> = ({ onCreate }) => {
    const [newStandardReplyModalIsOpen, setNewStandardReplyModalIsOpen] = useState(false);

    return (
        <>
            <div className={theme.container}>
                <FontAwesomeIcon icon={faEnvelope} size="3x" className={theme.envelopeIcon} />
                <div className={theme.heading}>
                    <Trans>You do not have any standard replies yet</Trans>
                </div>
                <div className={theme.info}>
                    <Trans>Add message templates that agents can use in their customer dialogues.</Trans>
                </div>
                <div className={theme.link} onClick={() => setNewStandardReplyModalIsOpen(true)}>
                    <button>
                        <Trans>Create a standard reply</Trans> <FontAwesomeIcon icon={faLongArrowRight} />
                    </button>
                </div>
            </div>

            <EditStandardReplyModal
                isOpen={newStandardReplyModalIsOpen}
                toggle={() => setNewStandardReplyModalIsOpen(false)}
                onSave={onCreate}
            />
        </>
    );
};

export default StandardRepliesEmpty;